import styled from 'styled-components';

export const InputWrapper = styled.div`
  display: block;
  position: relative;
  width: 100%;
`;

export const SpanWrapper = styled.div`
  padding: 4px 8px 4px 8px;
`;

export const SpanError = styled.span`
  color: ${(p) => p.theme.colors.status.cherryRed};
  font-size: 14px;
  font-weight: 400;
  overflow-wrap: break-word;
  text-align: justify;
  word-break: break-all;
  word-wrap: break-word;
`;
